import Vue from 'vue'

export default {
  apiPrefix: '/api/v2/sites',
  getSitePartitions: function ({siteId}) {
    return Vue.http.get(Vue.env.apiPath + this.apiPrefix + `/${siteId}/partitions`, Vue.auth.getBearerHeader())
  },
  getAllSitesArmingStatus: function () {
    return Vue.http.get(Vue.env.apiPath + '/api/v2/sites/arming-status', Vue.auth.getBearerHeader())
  },
  getArmingStatus: function ({siteId, sync}) {
    const query = sync ? '?sync=1' : ''
    return Vue.http.get(Vue.env.apiPath + this.apiPrefix + `/${siteId}/arming-status${query}`, Vue.auth.getBearerHeader())
  },
  updatePartitionArmingStatus: function ({siteId, partitionIds, armingAction}) {
    return Vue.http.post(Vue.env.apiPath + this.apiPrefix + `/${siteId}/partition-arming`, {
      arming_action: armingAction,
      partition_ids: partitionIds
    }, Vue.auth.getBearerHeader())
  }
}
